<h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{"recovery_password.reset_password" | translate}}</h4>
<span class="f-s-14 d-block f-s-14 m-t-8">
  {{"recovery_password.password_reset_done" | translate}}
</span>
<a href="javascript:void(0)" (click)="goLogin()" mat-stroked-button color="primary" class="w-100 m-t-8">
  {{"login.log_in" | translate}}
</a>
